import { Flex, IconButton, Image } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { FaBars } from "react-icons/fa"

import { UserMenu } from "@/components/molecules/UserMenu"
import Logo from "/assets/images/dory-logo.svg"

interface NavbarProps {
  onMenuToggle?: () => void
}

function Navbar({ onMenuToggle }: NavbarProps) {
  return (
    <Flex
      justify="space-between"
      position="sticky"
      color="white"
      align="center"
      bg="bg.muted"
      w="100%"
      top={0}
      p={{ base: 2, md: 4 }}
      zIndex={10}
    >
      {/* Mobile hamburger */}
      <IconButton
        display={{ base: "flex", md: "none" }}
        variant="ghost"
        aria-label="Open menu"
        onClick={onMenuToggle}
        minH="44px"
        minW="44px"
      >
        <FaBars />
      </IconButton>

      <Link to="/">
        <Image
          src={Logo}
          alt="Dory Swim School"
          maxW={{ base: "120px", md: "2xs" }}
          p={2}
        />
      </Link>

      <Flex gap={2} alignItems="center">
        <UserMenu />
      </Flex>
    </Flex>
  )
}

export default Navbar
